module.exports = __webpack_public_path__ + "static/media/alarm.88f68c75.svg";